import React, { useState, useRef, useEffect } from 'react';
import { Volume2, VolumeX, Play, Pause } from 'lucide-react'; // Instala lucide-react para iconos

const Reproductor = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio("https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/audios%2FWhatsApp%20Audio%202026-05-10%20at%2015.37.11.mp4?alt=media&token=327d8e04-e2d2-4fe8-8c39-3436c7988bb2"));

  useEffect(() => {
    // Configuramos el volumen al 30% para que no asuste
    audioRef.current.volume = 0.3;
    audioRef.current.loop = true;

    return () => {
      audioRef.current.pause();
    };
  }, []);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="audio-player-fixed">
      <button onClick={togglePlay} className="audio-toggle-btn">
        {isPlaying ? <Volume2 size={20} /> : <VolumeX size={20} />}
        <span>{isPlaying ? "DETENER BSO" : "ACTIVAR BSO"}</span>
      </button>

      <style jsx>{`
        .audio-player-fixed {
          position: fixed;
          bottom: 20px;
          left: 20px;
          z-index: 9999;
        }
        .audio-toggle-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          background: rgba(229, 123, 227, 0.9);
          color: white;
          border: none;
          padding: 10px 18px;
          border-radius: 50px;
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.2);
          transition: all 0.3s ease;
        }
        .audio-toggle-btn:hover {
          transform: scale(1.05);
          background: #3b203b;
        }
      `}</style>
    </div>
  );
};

export default Reproductor;